module.exports = __webpack_public_path__ + "img/Opinion2.c5067927.webp";